
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'classification_and_classificationof_OHSS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/classification_and_classificationof_OHSS.vue